import * as React from "react";
import {imageBaseUrl} from "config";
import RoundedButton from "components/roundedButton";
import {partnerOfferings} from "login/config";

interface IProps {
    duration?: number;
    text?: string;
    onFinish: () => void;
    utmSource?: string;
}

interface IState {
    time: number;
}
let timer = null;
const defaultDuration = 15;
const defaultText = "Please wait while we are processing.";
export default class Timer extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            time: props.duration ? props.duration : defaultDuration,
        };
    }
    public componentDidMount() {
        this.startTimer();
    }

    public startTimer() {
        timer = setInterval(() => {
            if (this.state.time > 0) {
                this.setState({
                    time: this.state.time - 1,
                });
            } else {
                clearInterval(timer);
                this.props.onFinish();
            }
        }, 1000);
    }
    public render() {
        return this.state.time >= 0 ?
            <div className="flex-column-center-row">
                <div className="flex-center" style={{fontSize: 14, fontWeight: "bold"}}>Please wait a while</div>
                <div style={{marginTop: 10, marginLeft: 11}}>
                    <img src={partnerOfferings[this.props.utmSource]?.loaderImage ? partnerOfferings[this.props.utmSource]?.loaderImage : `${imageBaseUrl}/img/consent/processing.png`}
                             alt="Thank You"
                             style={{width: 108, height: 108}}/>
                </div>
                <div style={{fontSize: 14, textAlign: "center", marginTop: 16, marginBottom: 24}}>
                    {this.props.text ? this.props.text : defaultText}
                </div>
                {this.state.time > 0 && <RoundedButton bgColor={partnerOfferings[this.props.utmSource]?.colors?.green} buttonText={`${this.state.time} sec`} size="small" />}
            </div> : null;
    }
}
